<script>
    import { navigate } from "svelte-routing";

    export let game;
    export let currency;
    export let type = '';

    let mouse = {x: 0, y: 0};

    let discount;
    $: discount = game.discount[currency.shorthand] != null ? game.discount[currency.shorthand] : game.discount;

    let lrd;
    $: lrd = game.lrd[currency.shorthand] != null ? game.lrd[currency.shorthand] : isNaN(game.lrd) ? 0 : game.lrd;
</script>

<tr on:mousemove={e => mouse = {x: e.layerX-25, y: e.layerY-60}} on:click={() => navigate(`details/${game.sku}`)}>
<td>
<b>{game.title}</b><br />
{#if Object.entries(game.pro).length !== 0}
    {#if Object.entries(game.pro).length % 2 != 0 || game.pro[game.pro.length-1].toDate() > Date.now()}
        <img src="/img/stadia_pro_badge_small.svg" class="pro-badge" alt="pro" />
    {/if}
{/if}
<span class="mid">
{game.type == 0 ? 'Game' :
    game.type == 1 && game.playable ? 'Bundle' :
    game.type == 1 ? 'Add-on Bundle' :
    game.type == 2 ? 'Add-on' :
    'Subscription'}
</span>
</td>
{#if type=='sale'}
    <td style="text-align: center">{(discount*100).toFixed(0)}%</td>
{/if}
<td style="text-align: end" class="price">
{#if game.price[currency.shorthand] == null}
    Not available
{:else if game.price[currency.shorthand] != null && game.price[currency.shorthand] != 0}
    {#if game.discountPro}
        <img src="/img/stadia_pro_badge_small.svg" class="pro-badge" alt="pro" />
    {/if}<span class="mid">
    {currency.symbol}{discount != 0 ? ((game.price[currency.shorthand] != null ? game.price[currency.shorthand] : 0) * (1.0 - discount)).toFixed(2) : (game.price[currency.shorthand] != null ? game.price[currency.shorthand] : 0).toFixed(2)}
    {#if discount != 0}
        <strike>{currency.symbol}{(game.price[currency.shorthand] != null ? game.price[currency.shorthand]:0).toFixed(2)}</strike>&nbsp;
    {/if}
</span>
{:else if game.free}
<span class="mid"><strong>FREE</strong></span>
{/if}
</td>
<td style="text-align: end" class="lrp">
    {#if game.price[currency.shorthand] != null && game.price[currency.shorthand] != 0}
        {currency.symbol}{((game.price[currency.shorthand] != null ? game.price[currency.shorthand] : 0) * (1.0 - lrd)).toFixed(2)}
    {/if}
    {#if lrd > 0}
    <span style={"top: "+mouse.y+"px; left: "+mouse.x+"px;"}>{(lrd*100).toFixed(0)}%</span>
    {/if}
</td>
<td style="text-align: end"><a href="https://stadia.google.com/store/details/{game.id}/sku/{game.sku}">Store Link</a>
{#if game.type < 2}
    <span class="purple">/</span> <a href="https://stadia.google.com/player/{game.id}">Play</a>
{/if}
</td>
</tr>

<style>
    :global(main.dark) a {
        filter: invert(1);
    }

    :global(tr:hover) td {
        background: #cbcbcb !important;
        cursor: pointer;
    }

    :global(main.dark) .purple {
        filter: invert(1);
    }

    .lrp span {
        visibility: hidden;
        width: 50px;
        background: #bbbbbb;
        color: #212121;
        text-align: center;
        padding: 5px 0;
        border-radius: 6px;
        position: absolute;
        z-index: 1;
    }

    .lrp:hover span {
        visibility: visible;
    }

    :global(main.dark) .pro-badge {
        filter: invert(1);
    }

    .pro-badge, .mid {
        vertical-align: middle;
    }

</style>